import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { ApiEndPoints, ApiRoot } from '../constants/api-endpoints';
import {
  CaseManageRequest,
  CaseQueryRequest,
} from '../models/case-integration.model';
import { Utils } from '../../Utils/utils';

@Injectable({
  providedIn: 'root',
})
export class CaseService {
  constructor(private api: ApiService) { }

  // This method is used to get case details
  getCaseDetail(
    req: {
      serialNumber: string,
      referenceNumber: string,
      loginName: string,
      dcMethod: string,
      memberNumber?: string,
      noOfDays?: string,
      status?: string,
      pageSize?: number,
      startRowNum?: number,
      newQuery?: boolean,
      dcEncryptedValue?: string,
    }
  ): Observable<any> {
    const payload = new CaseQueryRequest();
    payload.body.DCLoginName = req.loginName;
    payload.body.DCMethod = req.dcMethod;
    payload.body.DCReferenceNumber = req.referenceNumber;
    payload.body.DCEncryptedValue = req.dcEncryptedValue ? req.dcEncryptedValue : 'N';
    payload.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();
    payload.body.PageSize = req.pageSize ?? payload.body.PageSize;
    payload.body.StartRowNum = req.startRowNum ?? payload.body.StartRowNum;
    payload.body.NewQuery = req.newQuery ?? payload.body.NewQuery;
    let caseDetail = payload.body.DCIncomingHierarchy['ListOfDC Community Portal Mediation Cases IO'][
      'DC Community Portal Mediation Cases'
    ];
    caseDetail['Serial Number'] = req.serialNumber;
    caseDetail['DC Member Number'] = req.memberNumber ?? '';
    // caseDetail['DCNoOfDays'] = req.noOfDays ?? '';
    caseDetail['DC Status'] = req.status ?? '';

    return this.api.post(
      ApiRoot.DC_CASE_INTEGRATION_API,
      ApiEndPoints.QUERY_CASE,
      payload
    );
  }

  // This method is used to submit a new case note
  submitCaseNote(
    serialNumber: string,
    note: string,
    options?: {
      noteId?: string;
      referenceNumber?: string;
      loginName?: string;
      dcEncryptedValue?: string;
      isComplainantUser?: boolean;
    }
  ): Observable<any> {
    const payload = new CaseManageRequest();
    payload.body.DCLoginName = options?.loginName ?? '';
    payload.body.DCReferenceNumber = options?.referenceNumber ?? '';
    payload.body.DCEncryptedValue = options?.dcEncryptedValue ?? '';
    payload.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();

    const caseRecord =
      payload.body.DCIncomingHierarchy[
      'ListOfDC Community Portal Mediation Cases IO'
      ]['DC Community Portal Mediation Cases'];

    caseRecord['Serial Number'] = serialNumber;
    caseRecord['ListOfDC Community Portal Mediation Case Notes'][
      'DC Community Portal Mediation Case Notes'
    ] = [
      {
        Id: options?.noteId ?? '',
        Note: note,
        'DC Complainant Read Flg': options?.isComplainantUser ? 'Y' : 'N',
        'DC Respondent Read Flg': options?.isComplainantUser ? 'N' : 'Y',
        // 'Note Type': options?.noteType ?? 'Complainant Note',
      },
      ];

    return this.api.post(
      ApiRoot.DC_CASE_INTEGRATION_API,
      ApiEndPoints.MANAGE_CASE,
      payload
    );
  }

  // This method is used to update the read flag of case notes
  updateNotesReadFlag(
    serialNumber: string,
    noteUpdates: { id: string; complainantReadFlag?: string; respondentReadFlag?: string }[],
    options?: { referenceNumber?: string; loginName?: string; dcEncryptedValue?: string }
  ): Observable<any> {
    const payload = new CaseManageRequest();
    payload.body.DCMethod = 'NOTE_READ_FLAG_UPDATE';
    payload.body.DCLoginName = options?.loginName ?? '';
    payload.body.DCReferenceNumber = options?.referenceNumber ?? '';
    payload.body.DCEncryptedValue = options?.dcEncryptedValue ?? '';
    payload.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();

    const caseRecord =
      payload.body.DCIncomingHierarchy['ListOfDC Community Portal Mediation Cases IO'][
      'DC Community Portal Mediation Cases'
      ];

    caseRecord['Serial Number'] = serialNumber;
    caseRecord['ListOfDC Community Portal Mediation Case Notes'][
      'DC Community Portal Mediation Case Notes'
    ] = noteUpdates.map((note) => ({
      Id: note.id,
      'DC Complainant Read Flg': note.complainantReadFlag ?? '',
      'DC Respondent Read Flg': note.respondentReadFlag ?? '',
    }));

    return this.api.post(
      ApiRoot.DC_CASE_INTEGRATION_API,
      ApiEndPoints.MANAGE_CASE,
      payload
    );
  }
}
